<script setup lang="ts">
  defineProps<{
    label?: string;
    baseClass?: string;
  }>();

  const modelValue = defineModel<boolean>();
  const attrs = useAttrs();
</script>

<template>
  <UCheckbox
    v-model="modelValue"
    size="xl"
    :ui="{
      root: 'items-center',
      base: `ring-1 ring-white ${baseClass}`,
      label: 'text-white font-barlow text-base font-normal leading-none',
    }"
    :label="label"
    v-bind="attrs"
  >
    <template #label>
      <slot name="label"></slot>
    </template>
  </UCheckbox>
</template>
